import { render, staticRenderFns } from "./hi-button-poptip.vue?vue&type=template&id=3fbadf9e"
import script from "./hi-button-poptip.vue?vue&type=script&lang=ts"
export * from "./hi-button-poptip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports